<template>
	<div id="recharge">
		<InfoHeader />
		<!-- 充值中心 -->
		<img src="@/static/images/home/chongzhi_banner.png" class="banner" />
		<ul class="list">
			<li class="item" @click="menuItemClick('1')">
				<div class="l">
					<img src="@/static/images/home/huafei.png" />
					<p>话费充值</p>
				</div>
				<div class="r"><img src="@/static/images/home/right.png" /></div>
			</li>
			<li class="item" @click="menuItemClick('2')">
				<div class="l">
					<img src="@/static/images/home/shihua.png" />
					<p>中国石化</p>
				</div>
				<div class="r"><img src="@/static/images/home/right.png" /></div>
			</li>
			<li class="item" @click="menuItemClick('3')">
				<div class="l">
					<img src="@/static/images/home/shiyou.png" />
					<p>中国石油</p>
				</div>
				<div class="r"><img src="@/static/images/home/right.png" /></div>
			</li>
		</ul>
	</div>
</template>
<script>
import InfoHeader from '@/components/InfoHeader.vue';
export default {
	name: 'Home',
	components: {
		InfoHeader
	},
	methods: {
		menuItemClick(type) {
			this.$router.push({ path: './RechargeDetail?type=' + type });
		}
	}
};
</script>

<style lang="less" scoped>
#recharge {
	.banner {
		width: 750px;
		height: 296px;
		background-color: pink;
	}
	.list {
		padding-top: 20px;
		.item {
			margin: 0 auto;
			width: 690px;
			height: 151px;
			background-color: #ffffff;
			box-shadow: 0px 0px 10px 0px rgba(163, 163, 163, 0.45);
			border-radius: 10px;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.l {
				display: flex;
				align-items: center;
				padding-left: 17px;
				img {
					width: 117px;
					height: 117px;
					border: solid 1px #d3d3d3;
				}
				p {
					padding-left: 64px;
					font-family: PingFang-SC-Bold;
					font-size: 30px;
					font-weight: bold;
					color: #3a3a3a;
				}
			}
			.r {
				img {
					width: 30px;
					height: 40px;
				}
				padding-right: 40px;
			}
		}
	}
}
</style>
